// The system the top bar names (G-7): the last one opened or tapped on the map, per galaxy, for this
// session. Until the player picks one it is their home system.
import { create } from 'zustand';

interface SelectedSystemState {
  byGalaxy: Record<string, string>;
  select(galaxyId: string, systemId: string): void;
}

export const useSelectedSystem = create<SelectedSystemState>()((set) => ({
  byGalaxy: {},
  select: (galaxyId, systemId) =>
    set((state) =>
      state.byGalaxy[galaxyId] === systemId
        ? state
        : { byGalaxy: { ...state.byGalaxy, [galaxyId]: systemId } }
    ),
}));

export const useSelectedSystemId = (
  galaxyId: string,
  homeSystemId: string | undefined
): string | undefined => useSelectedSystem((s) => s.byGalaxy[galaxyId]) ?? homeSystemId;
